/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ExportToCsv } from 'export-to-csv';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AskingAlert } from '../models/alert';
import { AlertService } from '../services/alert.service';
import { ApiService } from '../services/api.service';
import { PaginationFacadeService } from '../store/pagination/pagination-facade.service';
import { PaginationState } from '../store/pagination/pagination.state';
@Component({
  selector: 'app-global-list',
  template: ``,
})
export abstract class GlobalListComponent implements OnInit {
  dataItems: any = [];
  pagination: any;
  pageNumber = 1;
  per_page = 10;
  listApi!: string;
  customFilters: any = {};
  filterBody: any = {};
  detailUrl!: string;
  deleteUrl!: string;
  paginationUrl!: string;
  type: any;
  sort = {
    column: '',
    order: 'ASC',
  };
  sub!: Subscription;
  tableProps: any = {};
  sortColumn = 'id';
  searchStr = '';
  filters: any;
  posts: any[] = []; // for only tesing purpose
  formUrl = '';
  searchKey = 'search';
  userInfo: any;

  router = inject(Router);
  _route = inject(ActivatedRoute);
  apiService = inject(ApiService);
  paginationFacadeService = inject(PaginationFacadeService);
  alertService = inject(AlertService);
  toastr = inject(ToastrService);
  private dialog = inject(MatDialog);
  protected cdr = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    this.dataItems = [];
    this.pagination = {
      page: this.pageNumber,
      pages: this.per_page,
      per_page: 10,
      count: 100,
    };
    this.paginationUrl = `?page=${this.pagination.page}&per_page=${this.pagination.per_page}&SortColumn=${this.sortColumn}&sort_order=DESC`;
    this.getuser();
    this.sub = this._route.params.subscribe((params) => {
      this.type = params['type'];
    });
  }

  getuser() {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    const wareedlabAdminStr = localStorage.getItem('user');
    this.userInfo = wareedlabAdminStr ? JSON.parse(wareedlabAdminStr) : null;
    return this.userInfo;
  }

  getUpdatedPagination() {
    this.paginationFacadeService.pagination$
      .pipe(take(1))
      .subscribe((pagination: PaginationState) => {
        this.pageNumber = pagination?.pageNumber || 1;
        this.per_page = pagination?.pageSize || 10;
        if (!this.pagination) {
          this.pagination = {
            page: this.pageNumber,
            pages: this.per_page,
          };
        }
        this.paginationUrl = `?page=${this.pageNumber}&per_page=${this.per_page}`;
      });
  }

  onClickActionRoute(url: string): void {
    this.router.navigateByUrl(url);
  }

  onDateRange(_event: any): void {}

  onPagination(event: any): void {
    this.pageNumber = event.page;
    this.per_page = event.per_page;

    this.paginationFacadeService.setPaginationData({
      pageNumber: this.pageNumber,
      pageSize: this.per_page,
    });

    this.paginationUrl = `?page=${this.pageNumber}&per_page=${this.per_page}&SortColumn=${this.sortColumn}&sort_order=DESC`;
    this.getList();
  }

  setPage(event: any) {
    this.pageNumber = event.page;
    this.per_page = event.per_page;
    this.paginationFacadeService.setPaginationData({
      pageNumber: this.pageNumber,
      pageSize: this.per_page,
    });
    this.getListPost();
  }

  finalFilters(event: any): void {
    let filterUrl = '';

    if (event.sort) {
      filterUrl = filterUrl + event.sort;
    }
    if (event.range) {
      filterUrl = filterUrl + event.range;
    }
    if (event.search) {
      filterUrl = filterUrl + `&search=${event.search}`;
    }

    if (event.date) {
      filterUrl = filterUrl + event.date;
    }

    if (event.dateFilter) {
      filterUrl = filterUrl + event.dateFilter;
    }

    if (event.dropDownFilter) {
      filterUrl = filterUrl + event.dropDownFilter;
    }

    this.getList(filterUrl);
  }

  getList(_filterUrl?: any, isPublic?: boolean, isHideLoader?: boolean): void {
    this.getUpdatedPagination();
    let url = this.listApi;

    if (this.paginationUrl) {
      if (url.includes('?')) {
        url = url + '&' + this.paginationUrl.replace(/^\?/, '');
      } else {
        url = url + '?' + this.paginationUrl.replace(/^\?/, '');
      }
    }

    if (this.searchStr && !url.includes(this.searchKey)) {
      url = `${url}&${this.searchKey}=${this.searchStr}`;
    }

    Object.assign(this.filterBody, this.customFilters);
    if (this.customFilters.type) {
      // url = `${url}&type=${this.customFilters.type}`;
    }

    this.apiService.get(url, this.filterBody, isPublic, isHideLoader).subscribe((result: any) => {
      // this.posts = result;
      // let mock_response = this.getPosts();
      if (result?.status === 200) {
        if (result.data !== null && result.data !== undefined) {
          this.dataItems = result.data;
        } else {
          this.dataItems = [];
        }
        const paginationInfo =
          result.data?.pagination_info ||
          result.pagination ||
          result.data.pagination ||
          result ||
          {};

        this.pagination = {
          page:
            paginationInfo.page ||
            paginationInfo.currentPage ||
            paginationInfo.current_page ||
            this.pageNumber,

          pages:
            paginationInfo.pages ||
            paginationInfo.totalPages ||
            paginationInfo.total_pages ||
            paginationInfo.total_pages ||
            0,

          per_page: paginationInfo.per_page || paginationInfo.perPage || paginationInfo.limit || 0,

          count:
            paginationInfo.totalItems ||
            paginationInfo.count ||
            paginationInfo.total_items ||
            paginationInfo.total_count ||
            paginationInfo.total_records ||
            paginationInfo.total ||
            this.dataItems.total_slots ||
            0,
        };
        this.afterListResponse();
        // handle logs api res
      } else if (result?.data || Array.isArray(result)) {
        if (result.data !== null && result.data !== undefined) {
          this.dataItems = result.data;
        } else if (result) {
          this.dataItems = result;
        } else {
          this.dataItems = [];
        }
        const paginationInfo = result.data?.pagination_info || result.pagination || result || {};

        this.pagination = {
          page: paginationInfo.page || paginationInfo.currentPage || this.pageNumber,

          pages: paginationInfo.pages || paginationInfo.totalPages || 0,

          per_page: paginationInfo.per_page || paginationInfo.perPage || 0,

          count: paginationInfo.totalItems || paginationInfo.count || 0,
        };
        this.afterListResponse();
      } else if (result?.app_versions) {
        const versionsArray: any[] = [];
        Object.keys(result.app_versions).forEach((app) => {
          if (app !== 'wareedLabServicePrice') {
            Object.keys(result.app_versions[app]).forEach((type) => {
              const item = result.app_versions[app][type];
              versionsArray.push({
                app: app,
                type: type,
                forceUpdate: item.force,
                version: item.version,
              });
            });
          }
        });
        this.dataItems = versionsArray;
        this.afterListResponse();
      } else if (result?.status === 204) {
        this.dataItems = [];
        this.afterListResponse();
      } else {
        this.dataItems = [];
      }
      this.cdr.markForCheck();
    });
  }

  // for use of mock api testing purpose
  getPosts() {
    const startIndex = (this.pageNumber - 1) * this.pageNumber;
    const endIndex = startIndex + this.per_page;
    const totalPosts = this.posts.length;
    const totalPages = Math.ceil(totalPosts / this.per_page);

    return {
      status: 'success',
      statusCode: 200,
      message: 'OK',
      data: {
        list: this.posts.slice(startIndex, endIndex),
        pagination: {
          page: this.pageNumber,
          pages: totalPages,
          count: totalPosts,
          per_page: this.per_page,
          sort_by: 'id',
          sort_order: 'DESC',
        },
      },
      error: null,
    };
  }

  getListPost(obj?: any, isPublic?: boolean, isHideLoader?: boolean): void {
    this.getUpdatedPagination();
    const url = this.listApi;
    obj['page'] = this.pageNumber;
    obj['per_page'] = this.per_page;
    obj['sortColumn'] = this.sortColumn;

    if (this.searchStr) {
      obj['search'] = this.searchStr;
      this.searchStr = '';
    }

    this.apiService.post(url, obj, isPublic, isHideLoader).subscribe((result) => {
      if (result.statusCode === 200) {
        this.dataItems = result.data;
        // this.pagination = result.data.pagination_info;
        this.pagination.page = result.data?.pagination_info?.page || this.pageNumber;
        this.pagination.pages = result.data?.pagination_info?.pages;
        this.pagination.per_page = result.data?.pagination_info?.per_page;
        this.pagination.count = result.data?.pagination_info?.totalItems;
        this.afterListResponse();
      } else {
        this.dataItems = [];
        this.alertService.error({
          heading: 'Error',
          message: result.message,
        });
      }
      this.cdr.markForCheck();
    });
  }

  afterListResponse(): void {}

  onDelete(id: string) {
    const url = `${this.deleteUrl}?id=${id}`;
    const data: AskingAlert = {
      imagePath: 'icons/ic_delete_bg.svg',
      heading: 'Delete',
      message: 'Are you sure you want to delete this record?',
      leftButton: 'Delete',
      rightButton: 'Cancel',
    };
    this.alertService.askAlert(data, '400px').then((result) => {
      if (result.key) {
        this.apiService.delete(url).subscribe((result) => {
          if (result.status === 200) {
            this.getList();
            let message = '';
            if (typeof result.message === 'string') {
              message = result.message;
            } else if (result.message?.eng) {
              message = result.message.eng;
            } else {
              message = 'Something went wrong';
            }
            this.toastr.success(message);
          } else {
            this.alertService.error({
              heading: 'Error',
              message: result.message,
            });
          }
        });
      } else {
        // this.getList();
      }
    });
  }

  actionClicked(event: any) {
    if (event.action.type === 'view') {
      this.router.navigateByUrl(`${this.formUrl}${event.action.type}/${event.element.id}`);
    } else if (event.action.type === 'edit') {
      this.router.navigateByUrl(`${this.formUrl}${event.action.type}/${event.element.id}`);
    } else if (event.action.type === 'delete') {
      this.onDelete(event.element.id);
    }
  }

  searchData(event: any) {
    this.pageNumber = 1;
    this.per_page = 10;
    this.searchStr = event;
    this.getList();
  }

  searchPostData(event: any): void {
    this.pageNumber = 1;
    this.per_page = 10;
    this.searchStr = event;
    this.getListPost();
  }

  onChangeDateFilters(_event: unknown) {
    this.pageNumber = 1;
    this.per_page = 10;

    this.getList();
  }

  onDateFilters(_event: any) {}

  createFormDataDynamically(obj: any) {
    const formData = new FormData();
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== null && obj[key] !== undefined) {
        formData.append(key, obj[key]);
      }
    });
    return formData;
  }

  onChangefilter(_event: any) {}

  formatStatusKey(status: string): string {
    if (!status) {
      return '';
    }

    return status.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  }

  onExportCsv(data: any[], fileName: string) {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      filename: fileName,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
    this.toastr.success('CSV downloaded successfully!');
  }

  openModal(value?: any, component?: any, width?: any) {
    const dialogRef = this.dialog.open(component, {
      width: width || '600px',
      height: 'auto',
      autoFocus: false,
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-mat-dialog',
      data: value || {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getList();
      }
    });
  }
}
